import { createFileRoute } from "@tanstack/react-router";
import SubmitContent from "@/pages/SubmitContent";

export const Route = createFileRoute("/submit-content")({
  component: SubmitContent,
  head: () => {
    const title = "Submit Content | Garden-Review";
    const description = "Submit your gardening articles, press releases, or become a contributor at Garden-Review. Share your expertise with our community of gardening enthusiasts.";
    const url = "https://www.garden-review.co.uk/submit-content";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
});
